// Функция для поиска ключевых слов в строке option
export const findTranslationKeys = (option: string | number): string[] => {
  const optionStr = String(option).toLowerCase();
  const keys: string[] = [];
  
  // Поиск kWh (с учетом регистра и пробелов)
  if (optionStr.includes('kwh')) {
    keys.push('kwh');
  }
  
  // Поиск других единиц измерения
  if (optionStr.includes('km')) {
    keys.push('km');
  }
  
  if (optionStr.includes('s')) {
    keys.push('s');
  }
  
  if (optionStr.includes('h')) {
    keys.push('h');
  }
  
  return keys;
};

// Функция для извлечения числового значения из строки
export const extractNumber = (option: string | number): string => {
  if (typeof option === 'number') {
    return option.toString();
  }
  
  // Извлекаем числа из строки (включая десятичные)
  const numbers = option.match(/\d+(?:\.\d+)?/g);
  return numbers ? numbers.join(' ') : option;
};

// Функция для форматирования option с переводами
export const formatOptionWithTranslations = (
  option: string | number, 
  t: (key: string) => string
): string => {
  const keys = findTranslationKeys(option);
  const numberPart = extractNumber(option);
  
  if (keys.length === 0) {
    return String(option);
  }
  
  // Формируем строку с переводами
  const translatedUnits = keys.map(key => t(key)).join(' ');
  return `${numberPart} ${translatedUnits}`.trim();
};

// Функция для поиска всех единиц измерения в строке
export const findAllUnits = (option: string | number): { numbers: string[], units: string[] } => {
  const optionStr = String(option);
  
  // Извлекаем числа
  const numbers = optionStr.match(/\d+(?:\.\d+)?/g) || [];
  
  // Извлекаем единицы измерения
  const units: string[] = [];
  
  // kWh
  if (optionStr.toLowerCase().includes('kwh')) {
    units.push('kwh');
  }
  
  // km
  if (optionStr.toLowerCase().includes('km')) {
    units.push('km');
  }
  
  // s (секунды)
  if (optionStr.toLowerCase().includes('s')) {
    units.push('s');
  }
  
  // h (часы)
  if (optionStr.toLowerCase().includes('h')) {
    units.push('h');
  }
  
  return { numbers, units };
};

// Функция для создания переведенной строки с сохранением структуры
export const createTranslatedOption = (
  option: string | number,
  t: (key: string) => string
): string => {
  const { numbers, units } = findAllUnits(option);
  
  if (units.length === 0) {
    return String(option);
  }
  
  // Заменяем единицы измерения на переведенные версии
  let result = String(option);
  
  units.forEach(unit => {
    const regex = new RegExp(unit, 'gi');
    result = result.replace(regex, t(unit));
  });
  
  return result;
}; 